<ngui-map zoom="8" [center]="center">
  <heatmap-layer [data]="points"></heatmap-layer>
</ngui-map>
